import {Col, Divider, Row} from "antd";
import Logo from "./img/logo-gsg.png";
import React, {useEffect, useState} from "react";
import axios from "axios";
import "/node_modules/flag-icons/css/flag-icons.min.css";

import {NavLink} from "react-router-dom";

function Footer() {

    const [menu, setMenu] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getMenu = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/footer-menu/?populate[FooterMenu][populate][FooterMenuItems]=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        // console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setMenu(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getMenu().then(r => {});
    }, []);

    return (
            <Row className={"Footer"}>
                <Col span={24}>
                    <Divider/>
                    <Row style={{maxWidth: '1280px', margin: '0px auto', padding: '0 48px'}}>
                        <Col span={24} style={{display: 'flex', alignItems: 'center', justifyContent: 'left',}}>
                            <img src={Logo}
                                 alt={'Global Solutions Group logo'}
                                 style={{
                                     maxHeight: '26px',
                                     marginRight: '8px',
                                 }}
                            />
                            <small>GLOBAL SOLUTIONS GROUP</small>
                        </Col>
                    </Row>
                    <Row style={{maxWidth: '1280px', margin: '32px auto ', padding: '0 48px'}}>
                        {
                            (menu?.FooterMenu ?? []).map((item, value) => {
                                return <Col xs={24} sm={24} md={6} lg={6} xl={6} key={value}>
                                    <h5 style={{marginBottom: "16px"}}>{item.MenuTitle}</h5>
                                    {(item?.FooterMenuItems ?? []).map((menu, key) => {
                                        return <NavLink to={menu.URL} key={key}>{menu.Title}</NavLink>
                                    })}
                                </Col>
                            })
                        }
                    </Row>

                    <Row style={{maxWidth: '1280px', margin: '32px auto', padding: '0 48px'}}>
                        <Divider/>
                        <Col span={12}>
                            <img src={Logo}
                                 alt={'Global Solutions Group logo'}
                                 align={"top"}
                                 style={{
                                     maxHeight: '16px',
                                     marginRight: '4px',
                                 }}
                            />
                            <small>Gloabal Solutions Group</small>

                        </Col>
                        <Col span={12} style={{textAlign: 'right'}}>
                            <small>&#169; All rights reserved
                                <span className={"fi fi-lt"}
                                      style={{display: "inline-block", marginLeft: 24, marginRight: 4}}>
                                </span>&nbsp;Lithuania</small>
                        </Col>
                    </Row>

                </Col>
            </Row>
    )
}

export default Footer